import { CustomWindow } from "./createApolloClient";

declare let window: CustomWindow;
const defaultElasticUri =
  "https://api.test.eriksdigital.com/projectwiki-search/api/search";
export const elasticSearchUri =
  window?.env?.ELASTIC_API_URL ?? defaultElasticUri;
